import apiService from './apiService';

/**
 * Profile Service
 * Handles user profile management and password change requests.
 */
class ProfileService {
  /**
   * Get the authenticated user's profile details with role and account info
   * @returns {Promise<Object>} API response with user profile
   */
  async getProfile() {
    try {
      const response = await apiService.skaiOneRequest('/api/v1/account/profile', {
        method: 'GET',
        includeAuth: true,
      });
      return response;
    } catch (error) {
      console.error('Failed to get profile:', error);
      throw error;
    }
  }

  /**
   * Update user profile information (name, phone)
   * Synchronized across both account and skaix_account tables
   * @param {Object} data
   * @param {string} data.name - Updated full name
   * @param {string} [data.phone] - Updated phone number
   * @returns {Promise<Object>} API response with updated profile
   */
  async updateProfile(data) {
    try {
      const response = await apiService.skaiOneRequest('/api/v1/account/profile', {
        method: 'PUT',
        includeAuth: true,
        data: {
          name: data.name,
          phone: data.phone || '',
        },
      });
      return response;
    } catch (error) {
      console.error('Failed to update profile:', error);
      throw error;
    }
  }

  /**
   * Change account password
   * Verifies existing password and updates password hash across both account tables
   * @param {Object} data
   * @param {string} data.oldPassword - Current password
   * @param {string} data.password - New password
   * @param {string} [data.confirmPassword] - Confirmation of new password
   * @returns {Promise<Object>} API response
   */
  async changePassword(data) {
    try {
      const response = await apiService.skaiOneRequest('/api/v1/account/change-password', {
        method: 'POST',
        includeAuth: true,
        data: {
          oldPassword: data.oldPassword,
          password: data.password || data.newPassword,
          newPassword: data.newPassword || data.password,
          confirmPassword: data.confirmPassword || data.password,
        },
      });
      return response;
    } catch (error) {
      console.error('Failed to change password:', error);
      throw error;
    }
  }
}

export const profileService = new ProfileService();
export { ProfileService };
export default profileService;
